const DEFAULT_ABOUT_BODY =
  "D Site Solution은 웹사이트·플랫폼·AI·자동화를 아우르는\n통합 디지털 솔루션 기업입니다.\n\n단순한 홈페이지 제작이 아닌, 분석 → 전략 → 실행의 체계적 과정으로\n비즈니스 성장에 도움이 되는 디지털 환경을 구축합니다.";

function formatAboutParagraph(text) {
  const trimmed = (text || "").trim();
  if (!trimmed || trimmed.includes("\n")) return trimmed;

  if (trimmed.includes("기준으로 ")) {
    return trimmed.replace("기준으로 ", "기준으로\n");
  }

  if (trimmed.includes("과정으로 ")) {
    return trimmed.replace("과정으로 ", "과정으로\n");
  }

  return trimmed;
}

export function parseAboutBodyParagraphs(body) {
  const text = (body || "").trim() || DEFAULT_ABOUT_BODY;
  if (text.includes("\n")) {
    return text
      .split(/\n+/)
      .map((p) => formatAboutParagraph(p.trim()))
      .filter(Boolean);
  }

  const splitAt = text.indexOf(". ");
  if (splitAt > 0) {
    return [
      text.slice(0, splitAt + 1).trim(),
      formatAboutParagraph(text.slice(splitAt + 2).trim()),
    ].filter(Boolean);
  }

  return [formatAboutParagraph(text)];
}

const ABOUT_TITLE_HIGHLIGHT = "가능성을 개발합니다";

function normalizeAboutTitle(title) {
  return (title || "").replace("코드는 읽을 줄 아는", "코드를 읽을 줄 아는");
}

export function parseAboutTitle(title) {
  const lines = normalizeAboutTitle(title)
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);

  const fullText = lines.join("\n");
  const highlights = [ABOUT_TITLE_HIGHLIGHT, "코드를 읽을 줄 아는 개발자"];

  for (const highlight of highlights) {
    const highlightAt = fullText.indexOf(highlight);
    if (highlightAt >= 0) {
      return {
        line1Before: fullText.slice(0, highlightAt),
        line1Highlight: highlight,
        line1After: fullText.slice(highlightAt + highlight.length),
        line2: "",
      };
    }
  }

  const line1 = lines[0] || "";
  return {
    line1Before: "",
    line1Highlight: null,
    line1After: line1,
    line2: lines[1] || "",
  };
}

const DEFAULT_COMPANY_ABOUT_TITLE = [
  "디사이트솔루션은",
  "기업의 성장에 필요한",
  "디지털 환경을 설계합니다.",
];

const DEFAULT_COMPANY_ABOUT_BODY =
  "우리는 단순히 페이지를 만드는 회사가 아닙니다. 비즈니스 구조를 이해하고, 확장 가능한 시스템과 운영 환경까지 함께 설계합니다.";

export function parseCompanyAboutCopy(title, body) {
  const titleLines = String(title || "")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);
  const bodyText = String(body || "").trim();
  return {
    titleLines: titleLines.length ? titleLines : DEFAULT_COMPANY_ABOUT_TITLE,
    bodyText: bodyText || DEFAULT_COMPANY_ABOUT_BODY,
  };
}

/** 메인 About 섹션 — Vision / Mission 요약 */
export const VALUE_ITEMS = [
  {
    index: "01",
    label: "Vision",
    text: "확장성·연결성·지속가능성을 갖춘\n디지털 구조로 고객의 성장을 설계합니다.",
    delay: 0.12,
  },
  {
    index: "02",
    label: "Mission",
    text: "기획·디자인·개발·운영까지\n전 과정을 함께하는 all-in-one 디지털 파트너.",
    delay: 0.2,
  },
];

export const COMPANY_QUOTE = {
  lead: "우리는 문제를 디자인하고, 가능성을 개발합니다.",
  body:
    "기술과 창의성을 결합해 고객의 디지털 전환을 이끄는 파트너로서,\n기획·디자인·개발·브랜딩·AI·마케팅까지 연결합니다.",
};

/** 회사소개 페이지 히어로 */
export const COMPANY_HERO = {
  badge: "COMPANY",
  titleLines: ["디지털 솔루션의", "모든 것을 연결합니다"],
  subtitle: "기획부터 보수까지 책임지는 파트너",
  lines: [
    "웹사이트, 플랫폼, AI, 브랜딩, 마케팅까지",
    "비즈니스 성장에 필요한 모든 디지털 솔루션을 제공합니다.",
  ],
};

export const COMPANY_INTRO =
  "D Site Solution은 웹사이트 제작, 플랫폼 개발, 브랜딩, 마케팅, AI·자동화 시스템까지\n아우르는 통합 디지털 솔루션 기업입니다.\n\n단순한 서비스 제공을 넘어 기획에서 운영까지 브랜드의 성장을 함께 설계하며,\n출시 이후에도 안정적인 유지보수와 확장을 함께 고민합니다.";

export const COMPANY_PILLARS = [
  {
    index: "01",
    label: "Scalability",
    title: "확장성",
    text: "빠르게 변화하는 시장에 유연하게 대응하고,\n시장 확장에 최적화된 구조를 설계합니다.",
  },
  {
    index: "02",
    label: "Sustainability",
    title: "지속가능성",
    text: "장기적 운영을 고려한 안정적 모델로\n브랜드의 생명력을 길게 유지합니다.",
  },
  {
    index: "03",
    label: "Connectivity",
    title: "연결성",
    text: "고객·데이터·플랫폼을 유기적으로 연동하고\n채널 간 일관된 경험을 설계합니다.",
  },
  {
    index: "04",
    label: "Value Creation",
    title: "가치 창출",
    text: "브랜드 정체성과 고객 가치를 동시에 실현하는\n전략적 디지털 솔루션을 제공합니다.",
  },
];

export const COMPANY_STRENGTHS = [
  {
    title: "깊이 있는 기획력",
    text: "핵심 니즈를 파악하는 질문에서 시작합니다.\n비즈니스 목표를 먼저 이해하고 최적의 솔루션을 설계합니다.",
  },
  {
    title: "복잡함도 심플하게",
    text: "복잡함을 덜어내고 본질에 집중합니다.\n직관적인 구조와 콘텐츠로 방문자의 행동을 유도합니다.",
  },
  {
    title: "눈에 보이는 성과 입증",
    text: "정량적 데이터로 증명된 결과를 만듭니다.\n브랜드 노출과 비즈니스 성장을 동시에 추구합니다.",
  },
];

export const COMPANY_PROCESS = [
  {
    step: "01",
    title: "분석",
    text: "현재 기업 현황, 시장 환경,\n디지털 인프라를 체계적으로 분석합니다.",
  },
  {
    step: "02",
    title: "전략",
    text: "웹·플랫폼 구조, 기능 설계,\n구축 전략과 콘텐츠 방향을 수립합니다.",
  },
  {
    step: "03",
    title: "실행",
    text: "개발·런칭·운영까지 책임지며\n지속 가능한 성장 구조를 완성합니다.",
  },
];

export const COMPANY_CERTIFICATIONS = [
  "중소벤처기업부 창업기업",
  "중소기업",
  "여성기업",
  "벤처기업",
];

export const COMPANY_MILESTONES = [
  "6개 이상 제휴사 전용 플랫폼 구축",
  "커머스·교육·공공기관 웹사이트 기획/구축",
  "다국어 웹사이트 기획 및 기술 적용",
  "에듀테크 기반 AI 피드백 플랫폼 R&D",
  "AI 웹 소프트웨어 모듈 개발 및 상용화",
];

export const COMPANY_FACTS = [
  { label: "설립", value: "2024" },
  { label: "본사", value: "경기 김포" },
  { label: "전문 분야", value: "Web · Platform · AI" },
];

export const COMPANY_SERVICES_SUMMARY = [
  "반응형 웹 · 기업 홈페이지",
  "웹 플랫폼 · 관리자 시스템",
  "AI · 업무 자동화",
  "브랜딩 · 디지털 마케팅",
];
